var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divide-y divide-secondary flex flex-wrap"},_vm._l((_vm.randomRows),function(i){return _c('div',{key:`i${i}`,staticClass:"bg-white shadow overflow-hidden sm:rounded-lg m-4 w-96 h-64"},_vm._l((_vm.n),function(j){return _c('div',{key:`j${j}`,class:['linear-background flex m-6 h-3 rounded-full', _vm.randomWidth()]})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }